let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hwfmi")).then(() => parcelRequire('fIm7T'));